export const SUBSCRIPTION_TEST_MODE_KEY = 'topswe.subscriptionTestMode';

export function isSubscriptionTestModeAvailable() {
  if (process.env.REACT_APP_ENABLE_SUBSCRIPTION_TEST_MODE === 'true') return true;
  if (typeof window === 'undefined') return false;
  return ['localhost', '127.0.0.1'].includes(window.location.hostname);
}

export function isSubscriptionTestModeEnabled() {
  if (typeof window === 'undefined') return false;
  if (!isSubscriptionTestModeAvailable()) return false;
  if (new URLSearchParams(window.location.search).get('debug') === 'True') {
    window.localStorage.setItem(SUBSCRIPTION_TEST_MODE_KEY, 'enabled');
    return true;
  }
  if (new URLSearchParams(window.location.search).get('debug') === 'true') {
    window.localStorage.setItem(SUBSCRIPTION_TEST_MODE_KEY, 'enabled');
    return true;
  }
  return window.localStorage.getItem(SUBSCRIPTION_TEST_MODE_KEY) === 'enabled';
}

export function setSubscriptionTestMode(enabled) {
  if (typeof window === 'undefined') return;
  if (enabled && isSubscriptionTestModeAvailable()) {
    window.localStorage.setItem(SUBSCRIPTION_TEST_MODE_KEY, 'enabled');
  } else {
    window.localStorage.removeItem(SUBSCRIPTION_TEST_MODE_KEY);
  }
}
